export default {
    no_reservation_message:
        'К сожалению, мы не смогли найти никаких бронирований, соответствующих вашим выбранным фильтрам или у вас в данный момент нет активных бронирований.',
    no_timeline_reservation_message: 'К сожалению, мы не нашли бронирований на выбранную дату.',
    reservation_number: '🚀 Количество бронирований: {n}',
}
